import { useTranslation } from 'next-i18next';
import { Box, ButtonV2 as Button } from '@bridebook/ui';
import { IconChevronRight } from '@bridebook/ui/src/icons/dynamic';
import type { IMessageSubcomponentProps } from './message';
import componentStyles from './message.style';
import { IconClass } from '@bridebook/ui/src/icons/constants';

interface IProps extends Omit<IMessageSubcomponentProps, 'trimText'> {}

const TrimmedMessage = ({
  message,
  more,
  onReadMoreClick,
  response,
  isVenue,
  limitText,
  showFullResponse,
}: IProps) => {
  const { t } = useTranslation('supplier');
  const readMoreCaption = more ? t('button.readLess') : t('button.readMore');
  const styles = componentStyles();

  return (
    <Box style={styles.minifiedWrap}>
      <Box style={styles.shrunkTextWrap}>{limitText(message)}</Box>
      {showFullResponse && (
        <Box style={styles.responseContainer}>
          <Box style={styles.responseWrapper}>
            <Box style={styles.venueResponse}>
              {isVenue ? t('response.venue') : t('response.supplier')}
              {more && <span className={IconClass.Approve} style={styles.approveIcon} />}
            </Box>
            <Box style={styles.responseText}>{limitText(response?.message || '')}</Box>
          </Box>
        </Box>
      )}
      <Box style={styles.buttonContainer}>
        <Box style={styles.buttonWrapper}>
          <div onClick={onReadMoreClick}>
            <Button variant="link">
              {readMoreCaption}
              {!more && <IconChevronRight width={6} color="indigoCrush" />}
            </Button>
          </div>
          {}
        </Box>
        {showFullResponse && !more && (
          <Box style={styles.venueRespondedMark}>
            {isVenue ? t('responded.venue') : t('responded.supplier')}
            <span className={IconClass.Approve} style={styles.approveIcon} />
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default TrimmedMessage;
